console.log("✅ recipe.js.liquid loaded and running!");
const recipes = {
        drinks: [
            {
                recid: "drink1",
                rectitle: "TAKRA AYURVEDIC BUTTERMILK",
                preptime: "10 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"All Seasons",  
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/TAKRA-AYURVEDIC-BUTTERMILK_FinalProd1.png?v=1693624623",
              recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/TAKRA-AYURVEDIC-BUTTERMILK.gif?v=1693624746",
        ingredients: [
                "Plant-based OR Grass-Fed organic whole Yogurt - 2 cups",
                "Ginger - fresh - 1 small piece",
                "Cilantro - chopped - 3 tablespoons",
                "<a href=\"https://www.athreyaherbs.com/products/organic-cumin-cuminum-cyminum\" target=\"_blank\" rel=\"noopener noreferrer\">Cumin powder</a> - 1 teaspoon",
                "Himalayan salt - 1 teaspoon",
                "Hing powder  - ¼ teaspoon (optional)",
                "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - ½ teaspoon",
                "Lemon OR Lime juice - 2 teaspoons",
                "Water - 2 cups"
            ],

                steps: ["Blend all ingredients &amp; drink fresh."],
                bgColor: "#608136"
            },
            {
                recid: "drink2",
                rectitle: "GHEE OR COCONUT OIL ROASTED DATE MIX",
                preptime: "15 Minutes",
                recdosha: "Possibly Balances Pitta & Vata Doshas",
                serves:"6 People",
                recseason:"Fall & Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GHEE-OR-COCONUT-OIL-ROASTED-DATE-MIXFinalProd.png?v=1693625713",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GHEE-OR-COCONUT-OIL-ROASTED-DATE-MIX.gif?v=1693625714",      
                ingredients: [
                    "Ghee OR Coconut oil - 2-3 tablespoons",
                    "Dates - peeled &amp; sliced - 10 dates",
                    "Coconut-grated - 1 cup",
                    "Sesame seeds - ¼ cup",
                    "Flax seeds - ½ cup",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-shatavari-asparagus-racemosus\" target=\"_blank\" rel=\"noopener noreferrer\">Organic Shatavari powder</a> - 2 tablespoons (optional)",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cinnamon-cinnamomum-burmanii\" target=\"_blank\" rel=\"noopener noreferrer\">Cinnamon powder</a> - ½ teaspoon",
                    "Almond milk - 1 cup"
                ],
                steps: [
                    "Dry roast both seeds separately.",
                    "Gently roast the coconut, dates, and Shatavari powder in ghee OR coconut oil.",
                    "Mix all ingredients.",
                    "Finally, add cinnamon powder.",
                    "Serve with ½ cup of almond milk."
                ],
                bgColor: "#8A4D15"
            }
        ],
        snacks: [
            {
                recid: "snack1",
                rectitle: "ALMOND & HONEY CRISPS",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances Kapha & Vata Doshas",
                serves:"4 People",
                recseason:"Summer, Fall, And Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GHEE-OR-COCONUT-OIL-ROASTED-DATE-MIXFinalProd.png?v=1693625713",
                imgalttxt:"ALMOND-HONEY-CRISPS",
                recimgalttxt:"preparing ALMOND-HONEY-CRISPS gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/ALMOND-_-HONEY-CRISPS.gif?v=1693671938",      
                ingredients: [
                    "Almonds - cut into thin slivers - ¼ cup",
                    "Honey - 4 tablespoons",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-ashwagandha-withania-somnifera\" target=\"_blank\" rel=\"noopener noreferrer\">Organic Ashwagandha powder</a> - 2 tablespoons",
                    "<a href=\"https://www.athreyaherbs.com/pages/millet\" target=\"_blank\" rel=\"noopener noreferrer\">Millet flour</a> - ¼ cup ",
                    "<a href=\"https://www.athreyaherbs.com/products/maca-lepidium-meyenii\" target=\"_blank\" rel=\"noopener noreferrer\">Organic Maca powder</a> - 2 tablespoons ",
                    "Coconut cream - 4 tablespoons",
                    "Ghee OR Coconut oil - 3 tablespoons",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cinnamon-cinnamomum-burmanii\" target=\"_blank\" rel=\"noopener noreferrer\">Cinnamon powder</a> - ½ teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-ginger-zingiber-officinale\" target=\"_blank\" rel=\"noopener noreferrer\">Ginger powder</a> - ½ teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-nutmeg-myristica-fragrans\" target=\"_blank\" rel=\"noopener noreferrer\">Nutmeg powder</a> - ¼ teaspoon"
                ],
                steps: [
                    "Lightly roast the almonds in ghee OR coconut oil until golden brown and set aside.",
                    "Mix the millet flour, ashwagandha powder, and maca powder well. Lightly roast them with ghee OR coconut oil and set aside.",
                    "Add the almonds to the roasted millet, Ashwagandha, and maca mix.",
                    "Now, mix the spice powders in.",
                    "Add the coconut cream and a little water to turn it into a firm dough.",
                    "In a flat pan, heat some ghee OR coconut oil, shape the dough however you want, and add it to the pan.",
                    "Once mildly brown &amp; crispy, remove from the pan and let it cool.",
                    "Serve at room temperature with a drizzle of honey on top."
                ],
                bgColor: "#F2A000"
            },
            {
                recid: "snack2",
                rectitle: "FLAX SEEDS & HONEY BALLS",
                preptime: "25 Minutes",
                recdosha: "Possibly Balances Kapha & Vata Doshas",
                serves:"4 People",
                recseason:"All Seasons, Especially Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GHEE-OR-COCONUT-OIL-ROASTED-DATE-MIXFinalProd.png?v=1693625713",
                imgalttxt:"ALMOND-HONEY-CRISPS",
                recimgalttxt:"preparing ALMOND-HONEY-CRISPS gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/ALMOND-_-HONEY-CRISPS.gif?v=1693671938",      
                ingredients: [
                    "Flax seeds - 3 tablespoons",
                    "Chia seeds - 1 tablespoon",
                    "Pumpkin seeds - 2 tablespoons",
                    "Honey - 4 tablespoons",
                    "Pineapple - dried - 2 tablespoons"
                ],
                steps: [
                    "Dry roast each of the seeds separately.",
                    "Cut the dried pineapple into small pieces.",
                    "Add all the ingredients into a bowl and mix well.",
                    "Pour in the honey & mix.",
                    "If needed roll into balls OR your desired shape & serve."
                ],
                bgColor: "#5B2E16"
            },
            {
                recid: "snack3",
                rectitle: "BANANA & DATES NUGGETS",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances Vata & Pitta Doshas",
                serves:"4 People",
                recseason:"Summer & Fall",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BANANA-_-DATES-NUGGETSFinalProd.png?v=1693672593",
                imgalttxt:"banana and dates nugget",
                recimgalttxt:"preparing BANANA DATES NUGGETS gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BANANA-_-DATES-NUGGETS.gif?v=1693672593",      
                ingredients: [
                    "Banana - 2",
                    "Dates - 6",
                    "<a href=\"https://www.athreyaherbs.com/products/kapi-kacchu-mucuna-pruriens\" target=\"_blank\" rel=\"noopener noreferrer\">Organic Kapikachu powder</a> OR <a href=\"https://www.athreyaherbs.com/products/maca-lepidium-meyenii\" target=\"_blank\" rel=\"noopener noreferrer\">Maca powder</a> - 4 tablespoons",
                    "Sesame seeds - 1 tablespoon",
                    "Ghee OR Coconut oil - 4 tablespoons",
                    "Coconut milk - 4 tablespoons (alternatively, you can add water)"
                ],
                steps: [
                    "Slice the bananas into moderately thin 2-inch long slices and keep them aside.",
                    "Blend the dates with coconut milk OR water (enough to make a thin batter).",
                    "Add the Maca & Kapikacchu powders to make a batter of pancake consistency.",
                    "Toast the sesame seeds & add them to the batter.",
                    "Heat some ghee OR coconut oil in a pan. Dip each banana slice in the batter and sear in the pan until golden brown on each side.",
                    "Serve hot OR cold."
                ],
                bgColor: "#F2CB00"
            },
            {
                recid: "snack4",
                rectitle: "BRAZILIAN NUT BAR",
                preptime: "45 Minutes",
                recdosha: "Possibly Balances Vata Doshas",
                serves:"6 People",
                recseason:"All Seasons",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BRAZILIAN-NUT-BARFinalrod.png?v=1693672710",
                imgalttxt:"BRAZILIAN nut bar stacked placed ona cutting board",
                recimgalttxt:"preparing BRAZILIAN NUT BAR gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BRAZILIAN-NUT-BAR.gif?v=1693672711",      
                ingredients: [
                    "Pecans - 4 tablespoons",
                    "Chia seeds - 1 tablespoons",
                    "Cranberries - dried or fresh - 4 tablespoons",
                    "Cocoa powder - 2 tablespoons",
                    "Ghee OR Coconut oil - 2 tablespoons",
                    "Almond Flour - 2 tablespoons",
                    "Oats - old fashioned - 1.5 cups",
                    "Maple syrup - 6 tablespoons",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cinnamon-cinnamomum-burmanii\" target=\"_blank\" rel=\"noopener noreferrer\">Cinnamon powder</a> - ½ teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-nutmeg-myristica-fragrans\" target=\"_blank\" rel=\"noopener noreferrer\">Nutmeg powder</a> - ¼ teaspoon"
                ],
                steps: [
                    "Mix all the ingredients in a bowl till it becomes a thick paste.",
                    "Layer the mix onto a tray lined with parchment paper.",
                    "Preheat the oven & bake it at 325℉ for 20-25 minutes.",
                    "Once cool, slice into bars."                    
                ],
                bgColor: "#A83E45"
            },
            {
                recid: "snack5",
                rectitle: "ALMOND FENUGREEK DIP",
                preptime: "45 Minutes",
                recdosha: "Possibly Balances Pitta & Vata Doshas",
                serves:"4 People",
                recseason:"Fall & Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/ALMOND-FENUGREEK-DIPFinalProd.png?v=1693673465",
                imgalttxt:"ALMOND FENUGREEK DIP in a bowl",
                recimgalttxt:"preparing ALMOND FENUGREEK DIP gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/ALMOND-FENUGREEK-DIP.gif?v=1693673465",      
                ingredients: [
                    "Almonds - soaked - 1/2 cup OR Almond flour - 1 cup",
                    "Tamarind - 3/4th tablespoon",
                    "Himalayan salt - 1/2 teaspoon",
                    "Cocoa powder - 2 tablespoons",
                    "Ginger - fresh - 1 inch (approx.)",
                    "Onion - chopped - 1/2 cup",
                    "<a href=\"https://www.athreyaherbs.com/products/fenugreek-seeds\" target=\"_blank\" rel=\"noopener noreferrer\">Fenugreek seeds</a> - 1 tablespoon",
                    "Ghee OR Coconut oil - 2 tablespoon",
                    "Jaggery OR Brown sugar - 1 tablespoon",
                    "Water - as needed"
                ],
                steps: [
                    "Peel the soaked almonds (to save time you can use almond flour)",
                    "Soak the tamarind in about 1/4 cup of water till it softens.",
                    "Use your fingers to crush & dissolve the tamarind pulp in the water as much as possible. Discard the more fibrous pulp and save the water.",
                    "In a pan, roast the fenugreek seeds in ghee OR coconut oil till they release a fine aroma.",
                    "Add the onions and saute till golden brown.",
                    "Use a food processor to blend all the ingredients into a fine paste. Add enough water to get a nice dip consistency."
                ],
                bgColor: "#C17422"
            },
            {
                recid: "snack6",
                rectitle: "MUNG BEAN-SPINACH PATTIES",
                preptime: "45 Minutes",
                recdosha: "Possibly Balances Pitta & Vata Doshas",
                serves:"4 People",
                recseason:"Fall & Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/MUNG-BEAN-SPINACH-PATTIES.png?v=1693673624",
                imgalttxt:"MUNG BEAN SPINACH PATTIES being fried in a pan",
                recimgalttxt:"preparing MUNG BEAN SPINACH PATTIES gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/ALMOND-FENUGREEK-DIP.gif?v=1693673465",      
                ingredients: [
                    "Mung bean - soaked for 12 hours - 1 cup",
                    "Hemp seeds - 1 tablespoon",
                    "Spinach - 1 cup",
                    "Rosemary - fresh - 3 tablespoons",
                    "Chickpea flour - 2 tablespoons",
                    "Chives - 4 tablespoons",
                    "Himalayan salt - 1 teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - ½ teaspoon",
                    "Coconut - grated OR shredded - 2 tablespoons",
                    "Coconut oil - 2-3 tablespoons"
                ],
                steps: [
                    "Grind the soaked mung beans with a little water till it’s a hummus consistency.",
                    "Finely chop the spinach, rosemary, and chives. Add them to the mung bean paste.",
                    "Mix the hemp seeds & coconut shreds.",
                    "Add water if needed & slowly mix in the chickpea flour.",
                    "Add salt & pepper to the mix.",
                    "On a heated pan, pour some coconut oil till it coats the surface.",
                    "Make round patties with the mung batter and add them to the pan.",
                    "Keep flipping the patties until both sides are golden brown."
                ],
                bgColor: "#0A2405"
            },
            {
                recid: "snack7",
                rectitle: "GOLDEN NUGGETS",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Fall & Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GOLDEN-NUGGETSFinalProd.png?v=1693673791",
                imgalttxt:"golden nuggets placed in a bowl",
                recimgalttxt:"preparing golden nuggets gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GOLDEN-NUGGETS.gif?v=1693673793",      
                ingredients: [
                    "Mung bean flour - 1½ cup",
                    "Shallots - julienned - ¾ cup",
                    "Parsley - chopped - ½ cup",
                    "Cilantro - chopped - ½ cup",
                    "Ajwain seeds - 1 teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-coriander-coriandrum-sativum-1\" target=\"_blank\" rel=\"noopener noreferrer\">Coriander powder</a> - 1 teaspoon",
                    "Salt - 1 teaspoon",
                    "Coconut oil - 2 cups",
                    "Water - as needed"
                ],
                steps: [
                    "Mix all the ingredients. Add water to make a semi-solid paste or batter.",
                    "Scoop out tablespoon-sized nuggets of the batter.",
                    "Heat the coconut oil & deep fry till the nuggets are golden brown."
                ],
                bgColor: "#DF7316"
            },
            {
                recid: "snack8",
                rectitle: "GRAPE-ALOE DIP FOR GOLDEN NUGGETS",
                preptime: "10 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Fall & Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GRAPE-ALOE-DIP-FOR-GOLDEN-NUGGETS.png?v=1693673935",
                imgalttxt:"grape aloe dip in a bowl served with GOLDEN NUGGETS",
                recimgalttxt:"preparing Grape Aloe Dip For Golden Nuggets gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GRAPE-ALOE-DIP-FOR-GOLDEN-NUGGETS.gif?v=1693673935",      
                ingredients: [
                    "Black grapes - chopped - ½ cup",
                    "Pomegranate seeds - 1 cup",
                    "Aloe Vera (bite-size pieces) - ¼ cup",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-turmeric-curcuma-longa\" target=\"_blank\" rel=\"noopener noreferrer\">Turmeric powder</a> - ½ teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-nutmeg-myristica-fragrans\" target=\"_blank\" rel=\"noopener noreferrer\">Nutmeg powder</a> - ½ teaspoon",
                    "Honey - 1½ tablespoon"
                ],
                steps: [
                    "Cut the grapes into small pieces.",
                    "Crush & squeeze the juice out of the pomegranate seeds.",
                    "Add the aloe pieces & mix all ingredients together.",
                    "Pour in the honey & sprinkle the spices.",
                    "Give it a final stir & serve."
                ],
                bgColor: "#B98A42"
            }
        ],
        appetizers: [
            {
                recid: "appetizers1",
                rectitle: "ASPARAGUS & BARLEY SOUP",
                preptime: "60 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Late Winter & Spring",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/ASPARAGUS-_-BARLEY-SOUPFinalProd.png?v=1693674422",
                imgalttxt:"asparagus-soup",
                recimgalttxt:"preparing asparagus soup gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/ASPARAGUS-_-BARLEY-SOUP.gif?v=1693674423",      
                ingredients: [
                    "Asparagus - 15 sticks",
                    "Fennel bulb - 1 medium-sized",
                    "Barley - ½ cup",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - ½ teaspoon ",
                    "Garlic - crushed - 3 cloves (optional)",
                    "Flaxseeds - 1 tablespoon",
                    "Lime OR Lemon juice - 1½ tablespoons",
                    "Himalayan salt - 1 teaspoon",
                    "Ghee OR Coconut oil - 2 tablespoons"
                ],
                steps: [
                    "Rinse & cook the barley with a 1:8 water ratio (you could also use an Instapot). Cook until it’s soft.",
                    "Cut the asparagus into 1-inch pieces & julienne the fennel bulbs.",
                    "Heat ghee OR coconut oil in a pan, and saute the crushed garlic & black pepper until slightly brown.",
                    "Add the fennel & asparagus. Saute till golden brown.",
                    "Add the cooked barley & mix well.",
                    "Toss in some salt & add a squeeze of lime juice.",
                    "Sprinkle the soup with some dry-roasted flaxseeds & serve."
                ],
                bgColor: "#608136"
            },
            {
                recid: "appetizers2",
                rectitle: "BUTTERNUT & KALE SOUP",
                preptime: "45 Minutes",
                recdosha: "Possibly Balances All Doshas",
                serves:"4 People",
                recseason:"All Seasons",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BUTTERNUT-_-KALE-SOUPFinalProd.png?v=1693674549",
                imgalttxt:"image of butternut and kale soup",
                recimgalttxt:"preparing butternut kale soup gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BUTTERNUT-_-KALE-SOUP.gif?v=1693674549",      
                ingredients: [
                    "Butternut squash - cubed - 2 cups",
                    "Barley - 1/4 cup",
                    "Ginger - fresh - 1 tablespoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-coriander-coriandrum-sativum-1\" target=\"_blank\" rel=\"noopener noreferrer\">Coriander powder</a> - 1 tablespoon",
                    "Kale - chopped - 1 cup",
                    "Ghee OR Coconut oil - 2 tablespoons",
                    "Himalayan salt - 1 ½ teaspoons",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - 1 teaspoon"
                ],
                steps: [
                    "Boil the barley with 3 cups of water in a large pot until fairly soft. Drain the water.",
                    "Cook the butternut squash in a separate pot covered with water until soft.",
                    "Drain the squash and save the water.",
                    "In an electric blender, blend the cooked squash with some of its water to make a smooth mixture.",
                    "Blend about 1 oz of coriander powder, ginger, and black pepper with some of the squash water to make a thin paste.",
                    "Roast the spice paste in some ghee OR coconut oil in a large saucepan until it emits a nice aroma. Add the kale to this mix and saute until soft.",
                    "Add the cooked barley & salt. Continue cooking for about 5 minutes.",
                    "Finally, add the pureed squash and bring to a boil.",
                    "Take it off the heat & serve it hot."
                ],
                bgColor: "#DA8300"
            },
            {
                recid: "appetizers3",
                rectitle: "ALMOND BOK CHOY SOUP",
                preptime: "40 Minutes",
                recdosha: "Possibly Balances All Doshas",
                serves:"6 People",
                recseason:"Summer, Fall, And Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/ALMOND_BOK_CHOY_SOUPFinalProd.png?v=1693676644",
                imgalttxt:"image of almond bok choy soup",
                recimgalttxt:"preparing Almond bok Choy Soup gif",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/ALMOND-BOK-CHOY-SOUP.gif?v=1693676645",      
                ingredients: [
                    "Almond flour - ¼ cup",
                    "Veggie broth - 3 cups",
                    "Carrots - 2 medium-sized",
                    "Yams - 1 medium-sized",
                    "Bok choy - 2 baby heads",
                    "Rhubarb - 1 stick chopped - ¼ cup",
                    "Himalayan salt - 1 ½ teaspoons",
                    "Sesame oil - 4 tablespoons",
                    "Garlic - 4 cloves"
                ],
                steps: [
                    "Cut the carrots & yams into small chunks. Saute with oil until soft and set aside.",
                    "Cut the bok choy into 1-inch slices.",
                    "Finely chop the garlic & rhubarb.",
                    "In a bowl, mix some of the veggie broth into the almond flour to make a thin batter.",
                    "In a medium-sized saucepan, saute the garlic & rhubarb with the sesame oil until fragrant, and add the bok choy.",
                    "Once it softens, add the carrots & yams. Cook for another 5 minutes.",
                    "Add the almond-veggie broth batter.",
                    "Dilute it further with the remaining veggie broth & Himalayan salt and give it a quick boil.",
                    "Serve hot."
                ],
                bgColor: "#1F7000"
            },
            {
                recid: "appetizers4",
                rectitle: "RADISH STARTERS",
                preptime: "25 Minutes",
                recdosha: "Possibly Balances Kapha & Vata Doshas",
                serves:"4 People",
                recseason:"Spring & Early Summer",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/RADISH-STARTERSFinalProd.png?v=1693677117",
                imgalttxt:"image of radish starter served on a rice cracker",
                recimgalttxt:"preparing Radish starter",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/RADISH-STARTERS.gif?v=1693677118",      
                ingredients: [
                    "Radish - 8",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-turmeric-curcuma-longa\" target=\"_blank\" rel=\"noopener noreferrer\">Turmeric powder</a> - ¼ teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cumin-cuminum-cyminum\" target=\"_blank\" rel=\"noopener noreferrer\">Cumin powder</a> -  ¼ teaspoon",
                    "Himalayan salt - ¼ teaspoon",
                    "Apple cider vinegar - 1 tablespoon",
                    "Crackers OR Saltines - 8-10",
                    "Thyme leaves - 1-2 tablespoons"
                ],
                steps: [
                    "Wash & grate radishes.",
                    "Add the other ingredients & mix well.",
                    "Set aside. Mix well for 15 minutes.",
                    "Garnish with thyme leaves & serve on a cracker."
                ],
                bgColor: "#E95379"
            },
            {
                recid: "appetizers5",
                rectitle: "UMEBOSHI SALAD",
                preptime: "20 Minutes",
                recdosha: "Possibly Balances Kapha & Vata Doshas",
                serves:"4 People",
                recseason:"Spring, Summer, And Fall",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/UMEBOSHI-SALADFinalProd.png?v=1693677580",
                imgalttxt:"image of umeboshi salad prepared in a bowl",
                recimgalttxt:"gif of preparing Umeboshi salad ",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/UMEBOSHI-SALAD.gif?v=1693677581",      
                ingredients: [
                    "Umeboshi (pickled plum) - 2-3",
                    "Endive - chopped - 2",
                    "Split yellow mung bean - soaked for 6 hours - ½ cup",
                    "Cranberries - dried or fresh - 2 tablespoons",
                    "Pumpkin seeds - 2 tablespoons",
                    "Honey - 1 tablespoon",
                    "Ginger - fresh - 1-inch"
                ],
                steps: [
                    "Soak the split yellow mung bean for 4-6 hours.",
                    "After which, remove the umeboshi pit.",
                    "Chop the endives into small pieces.",
                    "Make the salad dressing by blending honey, ginger, and the umeboshi plums with water.",
                    "Toast the pumpkin seeds.",
                    "Toss all the ingredients, including the cranberries into a salad.",
                    "Serve once mixed well."
                ],
                bgColor: "#B32C2A"
            },
            {
                recid: "appetizers6",
                rectitle: "BEETS & DANDELION SALAD",
                preptime: "25 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Late Spring",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/UMEBOSHI-SALADFinalProd.png?v=1693677580",
                imgalttxt:"image of umeboshi salad prepared in a bowl",
                recimgalttxt:"gif of preparing Umeboshi salad ",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/UMEBOSHI-SALAD.gif?v=1693677581",      
                ingredients: [
                    "Beets medium-sized - 2",
                    "Dandelion greens - 1 bundle",
                    "Black raisins - soaked - 3 tablespoons",
                    "Walnuts - toasted - 3 tablespoons",
                    "Sesame seeds - toasted - 1 tablespoon",
                    "Lime OR Lemon juice - 1 ½ tablespoons",
                    "Himalayan salt - 1 teaspoon",
                    "Olive oil - 2 tablespoons",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - ⅓ teaspoon (approx.)",
                    "Goat cheese - 2 tablespoons (optional)"
                ],
                steps: [
                    "Wash & cut the dandelions into small pieces.",
                    "Peel & dice the beets into small cubes.",
                    "Toast the walnuts & sesame seeds separately. Keep them aside.",
                    "Puree the following ingredients to make the salad dressing: \
                      <ol class=\"salad-list\"> \
                      <li class=\"salad-list\">Toasted sesame seeds</li> <li class=\"salad-list\">Lime juice</li> <li class=\"salad-list\">Olive oil</li> \
                      <li class=\"salad-list\">Himalayan salt</li> <li class=\"salad-list\">Soaked raisins</li> <li class=\"salad-list\">Black pepper</li> </ol>",
                    "In a large bowl, toss all the ingredients together.",
                    "Garnish with the walnuts & Serve."
                ],
                bgColor: "#5E1D16"
            },
            {
                recid: "appetizers7",
                rectitle: "FRESH DILL & QUINOA SALAD",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances Pitta & Vata Doshas",
                serves:"4 People",
                recseason:"Fall & Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/FRESH-DILL-_-QUINOA-SALADFinalProd.png?v=1693678268",
                imgalttxt:"image of fresh dill &amp; quinoa salad prepared in a bowl",
                recimgalttxt:"gif of fresh dill &amp; quinoa salad prepared in a bowl",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/FRESH-DILL-_-QUINOA-SALAD.gif?v=1693678268",      
                ingredients: [
                    "Quinoa - 1 cup",
                    "<a href=\"https://www.athreyaherbs.com/products/fennel-seeds\" target=\"_blank\" rel=\"noopener noreferrer\">Fennel seeds</a> - 1 teaspoon",
                    "Dill greens - fresh - 1 cup",
                    "Pistachios - 3 tablespoons",
                    "Sesame oil OR Ghee - 2 tablespoons",
                    "Scallions - 4 stalks",
                    "Himalayan salt - 1 teaspoon",
                    "Olive oil - 2 tablespoons",
                    "Lime OR Lemon juice - 1 tablespoon",
                    "Goat cheese - 2 tablespoons (optional)"
                ],
                steps: [
                    "Rinse the quinoa and boil it in 1:1.75 parts of water.",
                    "When done, add the lime juice & salt, mix, and set aside.",
                    "Chop the dill greens and finely dice the scallions.",
                    "Heat the ghee OR sesame oil in a pan and roast the fennel seeds until it sizzles. Then add the scallions.",
                    "Keep stirring till golden brown, add the pistachios, and saute till it’s slightly roasted.",
                    "Add the chopped dill to the cooked quinoa.",
                    "Finally mix all the ingredients in a bowl and serve warm."
                ],
                bgColor: "#B28419"
            },
            {
                recid: "appetizers8",
                rectitle: "MILLET & CUMIN MEDLEY",
                preptime: "45 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Spring, Summer, And Fall",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/MILLET-_-CUMIN-MEDLEYFinalprod.png?v=1693678667",
                imgalttxt:"image of millet cumin medley being prepared in a pan",
                recimgalttxt:"gif of millet cumin medley being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/MILLET-_-CUMIN-MEDLEY.gif?v=1693678668",      
                ingredients: [
                    "<a href=\"https://www.athreyaherbs.com/pages/millet\" target=\"_blank\" rel=\"noopener noreferrer\">Organic millet</a> - 1½ cups",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cumin-seeds\" target=\"_blank\" rel=\"noopener noreferrer\">Cumin seeds</a> – 1 tablespoon",
                    "Leeks – chopped - 2 tablespoons",
                    "Ghee OR Coconut oil – 4 tablespoons",
                    "Assorted veggies - 2 cups",
                    "Himalayan salt – to taste",
                    "Lime OR Lemon juice – 1 ½ teaspoon",
                    "Cilantro greens - chopped - 4 tablespoons",
                    "Lime OR Lemon juice - 1 tablespoon",
                    "Cashews - a handful(optional)"
                ],
                steps: [
                    "Wash the millet till the water runs clear. Then boil with 5 cups of water.",
                    "Once the millet softens, pinch some of the cooked grains between your index finger & thumb to check if the grains have softened to the core. If so, take it off the flame.",
                    "Strain the millet and spread them evenly on a large plate to cool.",
                    "After which, mix with a sprinkle of salt & lime juice and set aside.",
                    "In a pan, roast the leeks, cumin seeds, and assorted veggies in ghee OR coconut oil until they’re soft.",
                    "Toss in the millet & mix well.",
                    "Garnish with cilantro & serve warm or cool."
                ],
                bgColor: "#EC741E"
            }
        ],
        "main Course": [
            {
                recid: "maincourse1",
                rectitle: "JICAMA & AVOCADO WRAPS",
                preptime: "20 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Summer & Fall",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/JICAMA_AVOCADO_WRAPS.png?v=1692007063",
                imgalttxt:"avocado wrap",
                recimgalttxt:"gif of JICAMA & AVOCADO WRAPS being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/JICAMA-_-AVOCADO-WRAPS.gif?v=1693678919",      
                ingredients: [
                    "Avocado - 1",
                    "Jicama wraps (Get it at Trader Joe's) OR Kale leaves - 8 pieces",
                    "Beet - 1 small-sized",
                    "Carrots - 1 small-sized",
                    "Sprouts - 2 tablespoons (any type is fine)",
                    "Pine nuts OR Sunflower seeds - 3 tablespoons",
                    "Thyme - chopped - 1 tablespoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - ½ teaspoon",
                    "Himalayan salt - 1 teaspoon",
                    "Lime OR Lemon juice - 2 teaspoons"
                ],
                steps: [
                    "Shred the beets & carrots.",
                    "Mix the sprouts with the shredded veggies.",
                    "Add the chopped thyme, spices, salt, and lime juice. Let them marinate for 15 - 20 minutes.",
                    "Cut the avocado into small chunks and add to the marinating veggies.",
                    "Give it a nice toss.",
                    "Scoop some of the avo-veggie mix with a spatula. Roll it inside a Jicama wrap OR Kale leaf and serve."
                ],
                bgColor: "#334122"
            },
            {
                recid: "maincourse2",
                rectitle: "BROCCOLI & TOFU STIR-FRY",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Spring",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BROCCOLI-_-TOFU-STIR-FRYFinalProd.png?v=1693679004",
                imgalttxt:"BROCCOLI &amp; TOFU STIR-FRY being prepared in a pan",
                recimgalttxt:"gif of BROCCOLI &amp; TOFU STIR-FRY being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BROCCOLI-_-TOFU-STIR-FRY.gif?v=1693679005",      
                ingredients: [
                    "Broccoli - 2 medium heads",
                    "Tofu - ½ lb",
                    "Garlic - finely diced - 5 - 6 cloves",
                    "Curry leaves - 30 (optional)",
                    "Mustard seeds - 1 teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-turmeric-curcuma-longa\" target=\"_blank\" rel=\"noopener noreferrer\">Turmeric powder</a> - 1 teaspoon",
                    "Tamarind - 1 ½ tablespoons soaked in ¼ cup hot water OR 1 teaspoon Lime OR Lemon juice",
                    "Himalayan salt - 1 ½ teaspoon",
                    "Ghee OR Coconut oil - 3 tablespoons"
                ],
                steps: [
                    "Wash & cut the broccoli into small pieces and set aside.",
                    "Cut the tofu into ½ inch cubes.",
                    "Heat 2 tablespoons of ghee OR coconut oil in a pan. Add the mustard seeds, diced garlic, and black pepper. Heat until the garlic is slightly brown.",
                    "Extract the tamarind pulp from the liquid it was soaking in.",
                    "In a separate pan heat 1 tablespoon of ghee OR coconut oil. Add the curry leaves, tofu, and tamarind paste.",
                    "Once golden brown, add the turmeric just before the tofu has absorbed all the tamarind paste. Add the tofu to the broccoli in a bowl & mix well.",
                    "Serve after a light sprinkle of salt."
                ],
                bgColor: "#9CAE1F"
            },
            {
                recid: "maincourse3",
                rectitle: "LENTILS & KOHLRABI STIR-FRY",
                preptime: "45 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Spring & Fall",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/LENTILS-_-KOHLRABI-STIR-FRYFinalProd.png?v=1693679325",
                imgalttxt:"LENTILS_KOHLRABI_STIR-FRY in a pan being prepared",
                recimgalttxt:"gif of LENTILS_KOHLRABI_STIR-FRY being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/LENTILS-_-KOHLRABI-STIR-FRY.gif?v=1693679326",      
                ingredients: [
                    "Lentils - ½ cup",
                    "Kohlrabi - 2",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cumin-seeds\" target=\"_blank\" rel=\"noopener noreferrer\">Cumin seeds</a> - 1 ½ teaspoon",
                    "Garlic - fresh - 4 cloves",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - ¾ teaspoonsn",
                    "Onions - ½ medium-sized",
                    "Cilantro - chopped- ¼ cup",
                    "Ghee OR Coconut oil - 2 tablespoons",
                    "Lime OR Lemon juice - 1 tablespoon",
                    "Himalayan salt - 1 ½ teaspoon"
                ],
                steps: [
                    "Wash & cook the lentils until soft. Set aside.",
                    "Peel the skin off the kohlrabi and cut it into small chunks.",
                    "Roast the cumin seeds, garlic, onions, and pepper in ghee OR coconut oil. Once they sizzle, add the kohlrabi & cook until soft.",
                    "Finally, add the cooked lentils and continue cooking them.",
                    "Turn off the heat and add some salt & lemon juice before serving."
                ],
                bgColor: "#AE8438"
            },
            {
                recid: "maincourse4",
                rectitle: "BUTTERNUT SQUASH & ASPARAGUS STIR-FRY",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances All Doshas",
                serves:"4 People",
                recseason:"Fall & Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BUTTERNUT-SQUASH-_-ASPARAGUS-STIR-FRY.png?v=1693679422",
                imgalttxt:"BUTTERNUT_SQUASH_ASPARAGUS_STIR-FRY in a pan",
                recimgalttxt:"gif of TTERNUT_SQUASH_ASPARAGUS_STIR-FRY being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BUTTERNUT-SQUASH-_-ASPARAGUS-STIR-FRY.gif?v=1693679423",      
                ingredients: [
                    "Butternut squash - diced - 1½ cups",
                    "Asparagus - chopped - 1 cup",
                    "Green onions - chopped - 4 tablespoons",
                    "Coconut - grated - ½ cup",
                    "Ginger - fresh & grated - 1 teaspoon",
                    "Coconut oil - 2 tablespoons",
                    "Himalayan salt - 1 teaspoon"
                ],
                steps: [
                    "In a skillet, saute the green onions, grated ginger, and coconut in the oil.",
                    "Once the coconut turns golden brown, add the asparagus & squash.",
                    "Sprinkle the Himalayan salt & cook for another 20 minutes.",
                    "Finally, add the cooked lentils and continue cooking them.",
                    "Serve hot."
                ],
                bgColor: "#7D3719"
            },
            {
                recid: "maincourse5",
                rectitle: "MILLET TABBOULEH",
                preptime: "40 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Spring",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/MILLET-TABBOULEH.png?v=1693679681",
                imgalttxt:"MILLET_TABBOULEH",
                recimgalttxt:"gif of MILLET_TABBOULEH being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/MILLET-TABBOULEH.gif?v=1693679681",      
                ingredients: [
                    "<a href=\"https://www.athreyaherbs.com/pages/millet\" target=\"_blank\" rel=\"noopener noreferrer\">Kodo millet</a>  - 1/2 cup",
                    "Parsley - 1 bundle",
                    "Mint - fresh - 20-25 leaves",
                    "Tomato - 1 medium-sized",
                    "Cucumber - 1 (preferably Persian variety)",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - ½  teaspoon",
                    "Lemon OR Lime juice - 1 ½ tablespoons",
                    "Green onions - chopped - 2 tablespoons",
                    "Himalayan salt - 1 ½ teaspoon",
                    "Olive oil - 2 tablespoons"
                ],
                steps: [
                    "Rinse the millet and boil it in 1:4 parts of water.",
                    "Once softened, add cold water, strain, and set aside.",
                    "Chop parsley & mint into small pieces.",
                    "Peel & dice the cucumber and tomatoes into small cubes.",
                    "Squeeze the lime juice into the millet. Mix well with some salt & pepper.",
                    "Add all the ingredients into a large mixing bowl, drizzle some olive oil, and mix.",
                    "Finally, garnish with the green onions and give it a final toss before serving."
                ],
                bgColor: "#769E1C"
            },
            {
                recid: "maincourse6",
                rectitle: "MULTIGRAIN SAVORY FLATBREAD",
                preptime: "25 Minutes",
                recdosha: "Possibly Balances Vata & Kapha Doshas",
                serves:"4 People",
                recseason:"Winter & Spring",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/MULTIGRAIN-SAVORY-FLATBREAD.png?v=1693679879",
                imgalttxt:"MULTIGRAIN_SAVORY_FLATBREAD served in a bowl",
                recimgalttxt:"gif of MULTIGRAIN SAVORY FLATBREAD being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/MULTIGRAIN-SAVORY-FLATBREAD.gif?v=1693679879",      
                ingredients: [
                    "Rice flour - 2 tablespoons",
                    "<a href=\"https://www.athreyaherbs.com/pages/millet\" target=\"_blank\" rel=\"noopener noreferrer\">Millet</a> flour - 1 tablespoon (optional)",
                    "Soy flour - 1 tablespoon",
                    "Chickpea flour - 3 tablespoons",
                    "Wheat flour - 1 tablespoon",
                    "Amaranth flour - 1 tablespoon (optional)",
                    "Onions - 1 medium-sized",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - 1 teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cumin-seeds\" target=\"_blank\" rel=\"noopener noreferrer\">Cumin seeds</a> - 1 ½ teaspoon</li>",
                    "Dill - fresh - 1 cup",
                    "Ghee OR Coconut oil - 4 tablespoons",
                    "Salt to taste"
                ],
                steps: [
                    "Mix each type of flour, one after another uniformly.",
                    "Finely chop the onions & dill greens and add the flour.",
                    "Add the spices & salt.",
                    "Peel & dice the cucumber and tomatoes into small cubes.",
                    "Mix with water to create a thick batter.",
                    "Heat the coconut oil OR ghee in a skillet.",
                    "Add the batter and spread it evenly.",
                    "When done, flip & cook both sides until brown.",
                    "Serve with your favorite dip, dairy, OR plant-based yogurt."
                ],
                bgColor: "#865E3B"
            },
            {
                recid: "maincourse7",
                rectitle: "TURMERIC RICE",
                preptime: "45 Minutes",
                recdosha: "Possibly Balances Vata & Pitta Doshas",
                serves:"4 People",
                recseason:"All Seasons",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/TURMERIC-RICEFinalProd.png?v=1693679988",
                imgalttxt:"TURMERIC_RICE served in a  bowl",
                recimgalttxt:"gif of turmeric rice being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/TURMERIC-RICE.gif?v=1693679989",      
                ingredients: [
                    "Basmati rice - 1 cup",
                    "Onions - chopped - 1 medium-sized",
                    "Green chili - chopped - 1 tablespoon",
                    "Cilantro - chopped - 3 tablespoons",
                    "<a href=\"hhttps://www.athreyaherbs.com/products/organic-cumin-seeds\" target=\"_blank\" rel=\"noopener noreferrer\">Cumin seeds</a> - 1 ½ teaspoon",
                    "Mustard seeds - 1 ½ teaspoon",
                    "Lime OR Lemon juice - 1 tablespoon",
                    "Salt - 1 teaspoon",
                    "Cashews - 20 pieces",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-turmeric-curcuma-longa\" target=\"_blank\" rel=\"noopener noreferrer\">Turmeric powder</a> - 1 teaspoon",
                    "Ghee OR Coconut oil - 2 tablespoons"
                ],
                steps: [
                    "Boil the basmati rice until mildly soft, but half-cooked.",
                    "Mix the rice with lime juice & salt.",
                    "Spread it out so they retain their long-grained structure.",
                    "Meanwhile, in another pan, roast the mustard seeds, cumin seeds, onions, cashews, and chili in some ghee OR coconut oil.",
                    "Once the onions are brown, add the turmeric powder.",
                    "Pour this mix onto the cooked rice and stir until well-coated.",
                    "Garnish with cilantro & serve hot."
                ],
                bgColor: "#E7A504"
            },
            {
                recid: "maincourse8",
                rectitle: "PONGAL",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances All Doshas",
                serves:"6 People",
                recseason:"All Seasons",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/PONGALFinalProd.png?v=1693680094",
                imgalttxt:"pongal being prepared in  BIG BOWL",
                recimgalttxt:"gif of pongal being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/PONGAL.gif?v=1693680095",      
                ingredients: [
                    "Rice (Brown) - ¾ cup",
                    "Split mung beans - ¾ cup",
                    "Green chili - chopped - 1 tablespoon",
                    "Ginger - fresh & chopped - 1 tablespoon",
                    "Black peppercorns - whole - 1 teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-turmeric-curcuma-longa\" target=\"_blank\" rel=\"noopener noreferrer\">Turmeric powder</a> - ½ teaspoon",
                    "Hing powder - 1 pinch (¼ tsp) (optional)",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cumin-seeds\" target=\"_blank\" rel=\"noopener noreferrer\">Cumin seeds</a> - 1 tablespoon",
                    "Curry leaves - 15-20 leaves",
                    "Cilantro - fresh & chopped - ¼ cup",
                    "Himalayan salt - 1 teaspoon",
                    "Mustard seeds - 1 teaspoon",
                    "Lemon OR Lime juice - 1-2 tablespoons",
                    "Ghee OR Coconut oil - 2 tablespoons",
                    "Water - as needed"
                ],
                steps: [
                    "Wash the rice & mung beans",
                    "Boil them with 4½ cups of water.",
                    "Add ginger, black peppercorn, cumin seeds, turmeric, hing, and Himalayan salt.",
                    "Boil until all the ingredients are cooked, soft, and mushy.",
                    "In a separate pan, roast mustard seeds and curry leaves in some ghee OR coconut oil.",
                    "Once the mushy rice is cooked, add the roasted ingredients and lemon juice.",
                    "Mix well, garnish with cilantro, and serve."
                ],
                bgColor: "#BF7D29"
            },
            {
                recid: "maincourse9",
                rectitle: "BASIL BROWN RICE",
                preptime: "45 Minutes",
                recdosha: "Possibly Balances Pitta & Vata Doshas",
                serves:"4 People",
                recseason:"Spring",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/BASIL-BROWN-RICE.png?v=1693680180",
                imgalttxt:"BASIL_BROWN_RICE being prepared in a frying pan",
                recimgalttxt:"gif of BASIL BROWN RICE being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/PONGAL.gif?v=1693680095",      
                ingredients: [
                    "Thai basil - 30 leaves",
                    "Yam - 1 medium-sized",
                    "Green onions OR Chives - chopped - 3 tablespoons",
                    "Brown rice - 1 cup",
                    "Ginger - fresh & grated - ½ teaspoon",
                    "Almonds - chopped - 3 tablespoons",
                    "Lime OR Lemon juice - 1 ½ tablespoons",
                    "Himalayan salt - 1 teaspoon",
                    "Ghee OR Coconut oil - 4 tablespoons"
                ],
                steps: [
                    "Rinse & cook rice with a 1:2.5 ratio of water.",
                    "Once soft, mix in some salt & lime juice.",
                    "Cut the yam into chunks and saute them in a tablespoon of ghee OR coconut oil & set aside.",
                    "In a large pan, heat 3 tablespoons of ghee OR coconut oil & roast the almonds. Add the ginger & green onions or chives. Cook until the almonds are brown.",
                    "Finally, add the basil leaves and turn off the heat.",
                    "Serve after mixing it in the brown rice & yams."
                ],
                bgColor: "#538621"
            },
            {
                recid: "maincourse10",
                rectitle: "KICHADI",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances All Doshas",
                serves:"2-6 People",
                recseason:"All Seasons",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/KICHADIFinalProd.png?v=1693680570",
                imgalttxt:"image of a KICHADI",
                recimgalttxt:"gif of Kichadi being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/KICHADI.gif?v=1693680572",      
                ingredients: [
                    "White rice - 1 cup (You can use brown rice during winter)",
                    "Whole mung beans - 1 cup",
                    "Himalayan salt - ¾ tablespoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cardamom-elettaria-cardamomum\" target=\"_blank\" rel=\"noopener noreferrer\">Cardamom seeds</a> - crushed - 1 tablespoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-turmeric-curcuma-longa\" target=\"_blank\" rel=\"noopener noreferrer\">Turmeric powder</a> - ½ tablespoon",
                    "Ginger - fresh & grated - 2 tablespoons",
                    "Ghee OR Coconut oil - ¼ cup",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cumin-seeds\" target=\"_blank\" rel=\"noopener noreferrer\">Cumin seeds</a> - 1 tablespoon",
                    "<a href=\"https://www.athreyaherbs.com/products/fennel-seeds\" target=\"_blank\" rel=\"noopener noreferrer\">Fennel seeds</a> - 1 tablespoon",
                    "Cashew nuts - raw - ½ cup",
                    "Mixed veggies - diced - Carrots, Green beans, and Zucchini OR Yams - 1½ cups"
                ],
                steps: [
                    "Dry roast the rice in a frying pan to make it lighter & easier to digest.",
                    "Rinse the roasted rice and cook it in a pot with water about 4” above the level of rice.",
                    "Add a pinch of salt to the water right before boiling to speed up its cooking time. Bring the rice to a boil.",
                    "Rinse the mung beans & add them to the pot of boiling rice.",
                    "Next, add the cardamom, turmeric, and ginger to the pot.",
                    "In a separate pan, roast the cumin, fennel, cashew nuts, and curry leaves in the ghee OR coconut oil till brown.",
                    "Add the roasted ingredients to the pot.",
                    "Mix it all till all the flavors are well-blended.",
                    "Serve once everything is soft, mushy & warm."
                ],
                bgColor: "#CEB71B"
            },
            {
                recid: "maincourse11",
                rectitle: "MUSHROOM FRIED RICE",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances Pitta & Vata Doshas",
                serves:"2",
                recseason:"Late Spring & Summer",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/MUSHROOM-FRIED-RICE.png?v=1693680673",
                imgalttxt:"image of MUSHROOM_FRIED_RICE in a frying pan",
                recimgalttxt:"gif of MUSHROOM FRIED RICE being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/MUSHROOM-FRIED-RICE.gif?v=1693680674",      
                ingredients: [
                    "Basmati rice - 1 cup",
                    "Oyster mushrooms - 1 ½ cups",
                    "Garlic - chopped - 5 cloves - 1 teaspoon",
                    "Ginger - fresh & chopped - 1 teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - 2 teaspoons",
                    "Chives - 4 tablespoons",
                    "Pistachios - 2 tablespoons",
                    "Ghee OR Coconut oil - 3 tablespoons",
                    "Sesame seeds (white) - 2 tablespoons",
                    "Lime OR Lemon juice - 2 tablespoons",
                    "Himalayan salt - 1 teaspoon"
                ],
                steps: [
                    "Cook the basmati rice with 2 ¼ cups of water.",
                    "Add ½ teaspoon of ghee OR coconut oil while cooking.",
                    "Mix the lime juice & salt with the cooked rice and set aside.",
                    "Saute the garlic & ginger in some ghee OR coconut oil in another pan.",
                    "Once fragrant, add the black pepper & chives. Mix in the mushrooms.",
                    "Finally, add the pistachios & sesame seeds.",
                    "Pour all the ingredients onto the rice. Give it one final toss & serve hot."
                ],
                bgColor: "#A3968A"
            }
        ],
        desserts: [
            {
                recid: "dessert1",
                rectitle: "OJAS RICE PUDDING",
                preptime: "45 Minutes",
                recdosha: "Possibly Balances Pitta & Vata Doshas",
                serves:"3-4 People",
                recseason:"Fall & Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/OJAS-RICE-PUDDINGFinalProd.png?v=1693681535",
                imgalttxt:"ojas rice pudding",
                recimgalttxt:"gif of OJAS RICE PUDDING being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/OJAS-RICE-PUDDING.gif?v=1693681536",      
                ingredients: [
                    "Rice - ½ cup",
                    "Dates - 4",
                    "Almonds - soaked - ½ cup",
                    "Coconut - shredded - ¼ cup",
                    "Poppy seeds - dry roasted - ½ tablespoon",
                    "Saffron - 10-25 threads",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Cardamom</a> - 2 pods OR ¼ teaspoon powder"
                ],
                steps: [
                    "Cook the ½ cup rice with 3 cups of water i.e. with a 1:6 water ratio.",
                    "Blend the dates, almonds, and poppy seeds.",
                    "Combine them with the rice and cook for 10 minutes.",
                    "Finally, add the shredded coconut, saffron, and cardamom.",
                    "Serve warm!"
                ],
                bgColor: "#E0260F"
            },
            {
                recid: "dessert2",
                rectitle: "DATE KISSES",
                preptime: "20 Minutes",
                recdosha: "Possibly Balances Pitta & Vata Doshas",
                serves:"6 People",
                recseason:"All Seasons",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/DATE-KISSESFinalPro.png?v=1693681635",
                imgalttxt:"DATE_KISSES on a cutting board",
                recimgalttxt:"gif of DATE KISSES being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/DATE-KISSES.gif?v=1693681636",      
                ingredients: [
                    "Medjool dates - 15",
                    "Mango - fresh & cubed - ⅓ cup",
                    "Oat flakes - 2 tablespoons",
                    "Almond flour - 1 tablespoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-black-pepper-piper-nigrum\" target=\"_blank\" rel=\"noopener noreferrer\">Black pepper powder</a> - ¼ teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cinnamon-cinnamomum-burmanii\" target=\"_blank\" rel=\"noopener noreferrer\">Cinnamon powder</a> - ¼ teaspoon"
                ],
                steps: [
                    "Chop & make a paste out of the dates.",
                    "Dry roast the oat flakes.",
                    "Mix the mango pieces with the roasted oat flakes, almond flour, and throw in the black pepper powder.",
                    "Make small flat circular shapes of the date paste which will act like a sweet dumpling wrapper for the mango-oat filling.",
                    "Fill the date wrappers with the mango-oat mix at its core & seal them.",
                    "Sprinkle the kisses with some cinnamon powder & serve."
                ],
                bgColor: "#C0B806"
            },
            {
                recid: "dessert3",
                rectitle: "SPICED FRESH FRUIT BLEND PORRIDGE",
                preptime: "15 Minutes",
                recdosha: "Possibly Balances Pitta & Vata Doshas",
                serves:"4 People",
                recseason:"Summer & Fall",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/SPICED-FRESH-FRUIT-BLEND-PORRIDGEFinalProd.png?v=1693681773",
                imgalttxt:"SPICED_FRESH_FRUIT_BLEND_PORRIDGE in a bowl",
                recimgalttxt:"gif of SPICED FRESH FRUIT BLEND PORRIDGE being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/SPICED-FRESH-FRUIT-BLEND-PORRIDGE.gif?v=1693681773",      
                ingredients: [
                    "Apples - cut into small pieces - 1",
                    "Kiwi - cut into small pieces - 1",
                    "Pear - cut into small pieces - 1",
                    "Black grapes - cut in half - 20",
                    "Nuts (Pistachios, Pecans, and Almonds) - chopped - ¾ cup",
                    "<a href=\"https://www.athreyaherbs.com/pages/millet\" target=\"_blank\" rel=\"noopener noreferrer\">Millet flour</a> - ¾ cup",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-ginger-zingiber-officinale\" target=\"_blank\" rel=\"noopener noreferrer\">Ginger powder</a> - 1 teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cinnamon-cinnamomum-burmanii\" target=\"_blank\" rel=\"noopener noreferrer\">Cinnamon powder</a> - ¼ teaspoon",
                    "All spice powder - ½ teaspoon",
                    "Coconut oil - 2 ½ tablespoons",
                    "Maple syrup - ¼ cup"
                ],
                steps: [
                    "Mix the millet flour with 1 ½ cups of boiled water to make a fine puree.",
                    "Sprinkle in the spice powders.",
                    "Once the spiced millet puree is warm add all the fruits.",
                    "Roast the nuts in some coconut oil.",
                    "Mix the nuts into the fruity puree well.",
                    "Drizzle some maple syrup & serve."
                ],
                bgColor: "#724631"
            },
            {
                recid: "dessert4",
                rectitle: "GRAPEFRUIT & AMALAKI JAM ON RICE CAKE",
                preptime: "30 Minutes",
                recdosha: "Possibly Balances All Doshas",
                serves:"4 People",
                recseason:"Late Winter & Spring",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GRAPEFRUIT-_-AMALAKI-JAM-ON-RICE-CAKE.png?v=1693681893",
                imgalttxt:"GRAPEFRUIT_AMALAKI jam served ona rice cake",
                recimgalttxt:"gif of GRAPEFRUIT &amp; AMALAKI JAM being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/GRAPEFRUIT-_-AMALAKI-JAM-ON-RICE-CAKE.gif?v=1693681894",      
                ingredients: [
                    "Frozen Amalaki - 10 pieces (Get frozen Amla at Indian grocery stores) Substitute - Blueberries",
                    "Grapefruit - 1 medium-sized",
                    "Cassava root OR Arrowroot powder - 2 ½ tablespoons (Get it at Bob’s Red Mill OR any health food store)",
                    "Jaggery OR Brown Sugar - 4 tablespoons",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cinnamon-cinnamomum-burmanii\" target=\"_blank\" rel=\"noopener noreferrer\">Cinnamon powder</a>  - ½ teaspoon",
                    "Ginger - fresh & grated - 1 teaspoon",
                    "Rice cake - 4 pieces",
                    "Ghee OR Coconut oil - 2 tablespoons"
                ],
                steps: [
                    "Remove the rind of grapefruit & cut the flesh into medium-sized pieces.",
                    "Heat ghee OR coconut oil in a pan and then add the pieces of grapefruit & amalaki. Saute until slightly golden.",
                    "Heat 1 ½ cups of water in a saucepan and when it starts boiling, add the ginger. Mix the cassava OR arrowroot powder in to make a base. Simmer for 10 min.",
                    "Add the brown sugar OR jaggery & mix well.",
                    "Add the grapefruit & amalaki to the thick base.",
                    "Add cinnamon & mix well before taking it off the stove.",
                    "Spread it on a rice cake & serve as dessert."
                ],
                bgColor: "#DB3F41"
            },
            {
                recid: "dessert5",
                rectitle: "PRUNES & YELLOW MUNG BEAN PUDDING",
                preptime: "60 Minutes",
                recdosha: "Possibly Balances Pitta & Kapha Doshas",
                serves:"4 People",
                recseason:"Late Summer, Fall, And Winter",
                image: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/PRUNES-_-YELLOW-MUNG-BEAN-PUDDINGFinalProd.png?v=1693681994",
                imgalttxt:"PRUNES_YELLOW_MUNG_BEAN_PUDDING served in a bowl",
                recimgalttxt:"gif of PRUNES &amp; YELLOW MUNG BEAN PUDDING being prepared",
                recimg: "https://cdn.shopify.com/s/files/1/0130/1797/2795/files/PRUNES-_-YELLOW-MUNG-BEAN-PUDDING.gif?v=1693681995",      
                ingredients: [
                    "Split mung bean - ¾ cup",
                    "Prunes - pitted - 10",
                    "Jaggery OR Brown sugar - 2 tablespoons",
                    "Ghee OR Coconut oil - 3 tablespoons",
                    "Sesame seeds - 3 tablespoons",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-ginger-zingiber-officinale\" target=\"_blank\" rel=\"noopener noreferrer\">Ginger powder</a> - 1 teaspoon",
                    "<a href=\"https://www.athreyaherbs.com/products/organic-cardamom-elettaria-cardamomum\" target=\"_blank\" rel=\"noopener noreferrer\">Cardamom powder</a>  - ¼ teaspoon",
                    "Poppy seeds - 2 tablespoons (can be replaced with Almond flour) (optional)"
                ],
                steps: [
                    "Wash the split mung beans and boil them with 4 parts of water until soft & mushy",
                    "Soak the prunes in hot water for an hour OR boil them for 15 minutes. Puree them once soft.",
                    "Dry roast the poppy & sesame seeds separately until brown.",
                    "Once cool, blend the poppy seeds into a powder.",
                    "Keep the roasted sesame seeds aside.",
                    "Cook the pureed prunes & jaggery in some ghee OR coconut oil.",
                    "Mix the ginger, cardamom, and poppy seed powder and turn off the flame.",
                    "Garnish with sesame seeds before serving."
                ],
                bgColor: "#DAC400"
            }
        ]
    };

    function displayRecipes(category) {
    if (!recipes[category] || recipes[category].length === 0) {
        $("#recipe-container").html("<p>No recipes found in this category.</p>");
        return;
    }

    let listHTML = `<h2 class="menu-name">${category.charAt(0).toUpperCase() + category.slice(1)}</h2><ul class="recipe-list">`;
    recipes[category].forEach(recipe => {
        listHTML += `<li><a href="#${recipe.recid}" class="recipe-link">${recipe.rectitle}</a></li>`;
    });
    listHTML += `</ul>`;

    let recipesHTML = recipes[category].map(recipe => `
        <div id="${recipe.recid}" class="recipe-card">
            <h2 class="recipe-header">${recipe.rectitle}</h2>
            
            <div class="prep-info" style="background-color: ${recipe.bgColor}; padding: 15px; margin-top: 20px;">
            
                <div>
                    <span class="prep-title">Preparation Time:</span>
                    <span class="prep-text">${recipe.preptime}</span>
                </div>
                <div>
                    <span class="prep-title">Dosha:</span>
                    <span class="prep-text">${recipe.recdosha}</span>
                </div>
                <div>
                    <span class="prep-title">Serves:</span>
                    <span class="prep-text">${recipe.serves}</span>
                </div>
                <div>
                    <span class="prep-title">Season:</span>
                    <span class="prep-text">${recipe.recseason}</span>
                </div>
            </div>
            <button class="pprint-btn" onclick="printRecipe('${recipe.recid}', '${recipe.rectitle}')" style="background-color: ${recipe.bgColor};">🖨️ Print Recipe</button>
            <div class="recipe-container">
                <div class="recipe-image">
                    <img src="${recipe.image}" alt="${recipe.imgalttxt}" style="max-width: 100%;">
                </div>
                <div class="recipe-details">
                    <div class="details">
                        <h3 class="instru-title">Ingredients:</h3>
                        <ul class="ingred-list">
                            ${recipe.ingredients.map(ing => `<li class="list-text">${ing}</li>`).join("")}
                        </ul>
                    </div>
                </div>
            </div>

            <div class="recipe-instructions">
                <h3 class="instru-title">Preparation Steps</h3>
                <ol class="ingred-list">
                    ${recipe.steps.map(step => `<li class="list-text">${step}</li>`).join("")}
                </ol>
            </div>

            <div class="recipe-img-container">
                <img src="${recipe.recimg}" alt="${recipe.recimgalttxt}" style="max-width: 100%;">
            </div>

            <!-- Print Button -->
            <button class="print-btn" onclick="printRecipe('${recipe.recid}', '${recipe.rectitle}')">🖨️ Print Recipe</button>
        </div>
    `).join("");

    $("#recipe-container").html(listHTML + recipesHTML);
}

$(document).ready(function () {
    displayRecipes("drinks"); // Load drinks by default

    $(".menu-item").on("click", function () {
        $(".menu-item").removeClass("active"); // Remove underline from all
        $(this).addClass("active"); // Add underline to the clicked one

        let category = $(this).data("category");
        displayRecipes(category);
    });

    $(document).on("click", ".recipe-link", function (e) {
        e.preventDefault();
        let target = $(this).attr("href");
        $("html, body").animate({ scrollTop: $(target).offset().top - 50 }, 500);
    });
});

// Print Function
function printRecipe(recipeId, recipeTitle) {
    let recipeContent = document.getElementById(recipeId).innerHTML;
    let printWindow = window.open("", "_blank");

    printWindow.document.open();
    printWindow.document.write(`
        <html>
        <head>
            <title>${recipeTitle} - by Athreya Herbs.</title>
            <style>
                body { font-family: Arial, sans-serif; padding: 20px; }
                .recipe-card { width: 100%; max-width: 600px; margin: auto; padding: 20px; border: 1px solid #ddd; border-radius: 10px; }
                img { display: none; } /* Hide images in print mode */
                h2, h3 { color: #155122; }
                button { display: none; } /* Hide the print button */
            </style>
        </head>
        <body>
            <div class="recipe-card">${recipeContent}</div>
            <script>
                window.onload = function() {
                    setTimeout(() => { 
                        window.print();
                        window.close();
                    }, 500);
                };
            </script>
        </body>
        </html>
    `);
    printWindow.document.close();
}



document.addEventListener("DOMContentLoaded", function () {
    let scrollTopBtn = document.getElementById("scrollTopBtn");

    // Show button when scrolling down
    window.onscroll = function () {
        if (document.body.scrollTop > 1200 || document.documentElement.scrollTop > 1200) {
            scrollTopBtn.style.display = "block";
        } else {
            scrollTopBtn.style.display = "none";
        }
    };

    // Smooth scroll to top on click
    scrollTopBtn.addEventListener("click", function () {
        window.scrollTo({ top: 200, behavior: "smooth" });
    });
});
